import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editthemes, themes } from "../store/slices/theme";
import { Loader } from "semantic-ui-react";
import Navbarside from "../component/Navbarside";
import { useNavigate, useParams } from "react-router-dom";
import { API_PATHS } from "../utils/constants/api.constants";
import Footer from "./footer";

function EditTheme(e) {
  const [name, setName] = useState("");
  const [state, setState] = useState("");

  // alert-message

  const [alertname, setAlertname] = useState("");

  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const navigate = useNavigate("");
  const { loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { id } = useParams();
  localStorage.setItem("id", id);
  React.useEffect(() => {
    dispatch(themes())
      .unwrap()
      .then((data) => {
        if (data.user.data[0]._id == id) {
          setName(data.user.data[0].name);
          setState(data.user.data[0].state);
          setImage(data.user.data[0].image);
          setDescription(data.user.data[0].description);
        }
      })
      .catch(({ message }) => {
        alert(message);
      });
  }, [dispatch]);

  async function upload(e) {
    e.preventDefault();
    let item = { set: { name } };

    dispatch(editthemes(item))
      .unwrap()
      .then(() => {
        alert("Updated successfully");
        navigate("/ThemeList");
      })
      .catch(({ message }) => {
        alert(message);
      });
  }

  const save = (e) => {
    const regName = /^(([A-Za-z]+[,.]?[ ]?|[a-z]+['-]?|[0-9])+)$/;
    if (regName.test(name)) {
      setAlertname("");
    } else if (!regName.test(name) && name === "") {
      setAlertname("Please enter your name");
      e.preventDefault();
    } else {
      setAlertname("");
    }
  };

  const clear = () => {
    navigate(-1);
  };

  return (
    <body data-col="2-columns" className=" 2-columns ">
      <Navbarside />

      <div className="container-fluid pb-5 response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">
              <div className="row match-height">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title-wrap bar-warning">
                        <h4
                          className="card-title"
                          id="basic-layout-form-center"
                        >
                          Edit Theme
                        </h4>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="px-3">
                        <form className="form" onSubmit={upload}>
                          <div className="row justify-content-md-center">
                            <div className="col-md-6">
                              <div className="form-body">
                                <div className="form-group">
                                  <label for="placeTextarea">Theme Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    Placeholder="City Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                  />
                                  <p className="alert-message">{alertname}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          {loading ? (
                            <Loader active inline />
                          ) : (
                            <>
                              <div className="form-actions center">
                                <button
                                  type="submit"
                                  className="btn btn-blue"
                                  onClick={save}
                                >
                                  <i className="icon-note"></i> Save
                                </button>{" "}
                                &nbsp;
                                <button
                                  type="reset"
                                  className="btn btn-warning mr-1"
                                  onClick={clear}
                                >
                                  <i className="icon-trash"></i> Cancel
                                </button>
                              </div>
                            </>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </body>
  );
}
export default EditTheme;
